import React, { useRef, useState } from 'react';
import type { FC } from 'react';
import { Box, IconButton, Popover, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import { useTheme } from '@mui/material/styles';
import useSettings from '../../hooks/useSettings';
import { THEMES } from '../../constants';
import { ThemeToggle } from './ThemeToggle';

export const ThemePopover: FC = () => {
  const theme = useTheme();
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const { settings } = useSettings();

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleThemeSelected = (): void => {
    handleClose();
  };

  const selectedTheme = settings.theme ?? THEMES.LIGHT;
  const icon = selectedTheme === THEMES.DARK ? (
    <DarkModeIcon />
  ) : (
    <LightModeIcon
      sx={{
        color: 'black'
      }}
    />
  );

  return (
    <>
      <Tooltip
        title="Theme"
      >
        <IconButton
          ref={anchorRef}
          color="inherit"
          onClick={handleOpen}
        >
          {icon}
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top'
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 1.5,
              boxShadow: theme.shadows[10]
            }
          }
        }}
      >
        <Box>
          <ThemeToggle
            onThemeSelected={handleThemeSelected}
          />
        </Box>
      </Popover>
    </>
  );
};

export default ThemePopover;

